import { AsyncPipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@next/core-lib/i18n';

import { CropYearService } from '../../services/crop-year.service';

@Component({
  selector: 'app-crop-year-selector',
  templateUrl: './crop-year-selector.component.html',
  styleUrls: ['./crop-year-selector.component.scss'],
  imports: [AsyncPipe, MatFormFieldModule, MatSelectModule, MatTooltipModule, TranslatePipe],
})
export class CropYearSelectorComponent {
  private readonly cropYearService = inject(CropYearService);
  private readonly router = inject(Router);

  readonly readOnly = input(false);
  readonly cropYear$ = this.cropYearService.cropYear$;
  readonly availableCropYears$ = this.cropYearService.availableCropYears$;
  readonly notice$ = this.cropYearService.notice$;

  get tooltipCopy() {
    const path = (this.router.url ?? '/').split(/[?#]/, 1)[0];
    const isTgaRoute = path === '/tga' || path.startsWith('/tga/');

    return isTgaRoute
      ? {
          messageStartKey: 'cropYearNotice.tgaMessageStart',
          dashboardKey: 'cropYearNotice.tgaDashboard',
        }
      : {
          messageStartKey: 'cropYearNotice.messageStart',
          dashboardKey: 'cropYearNotice.dashboard',
        };
  }

  selectYear(cropYear: number): void {
    if (this.readOnly()) return;

    this.cropYearService.setCropYear(cropYear);
  }
}
